export default function (_this) {
  return {
    create (data, callback) {
      let { name, type, scope } = data
      let key = _this.getRef('customCode')
        .child(type)
        .push({
          name,
          code: '',
          scope
        }, () => {
          callback(key)
        }).key
    },
    read (callback, once) {
      _this.getRef('customCode')[once ? 'once' : 'on']('value', (snapshot) => {
        let code = {}

        new Promise((resolve) => {
          this.readCss((css) => {
            code.css = css
            resolve()
          })
        }).then(() => {
          this.readJs((js) => {
            code.js = js
          })
        }).then(() => {
          this.readHtml((html) => {
            code.html = html
            callback(code)
          })
        })
      })
    },
    readCss (callback) {
      let css = {}

      _this.getRef('customCode/css').orderByChild('name').once('value', (snapshot) => {
        if (snapshot.val()) {
          snapshot.forEach((child) => {
            css[child.key] = child.val()
          })
        }

        callback(css)
      })
    },
    readJs (callback) {
      let js = {}

      _this.getRef('customCode/js').orderByChild('name').once('value', (snapshot) => {
        if (snapshot.val()) {
          snapshot.forEach((child) => {
            js[child.key] = child.val()
          })
        }

        callback(js)
      })
    },
    readHtml (callback) {
      let html = {}

      _this.getRef('customCode/html').orderByChild('name').once('value', (snapshot) => {
        if (snapshot.val()) {
          snapshot.forEach((child) => {
            html[child.key] = child.val()
          })
        }

        callback(html)
      })
    },
    delete (key, type, callback) {
      _this.getRef('customCode')
        .child(type)
        .child(key)
        .remove((err) => {
          if (err) callback(err)
          else callback(null)
        })
    },
    update (key, type, code, callback) {
      _this.getRef('customCode')
        .child(type)
        .child(key)
        .child('code')
        .set(code, (err) => {
          if (err) callback(err)
          else callback(null)
        })
    },
    updateMetaData (data, callback) {
      let { name, key, type, scope } = data
      _this.getRef('customCode')
        .child(type)
        .child(key)
        .update({ name, scope }, (err) => {
          if (err) callback(err)
          else callback(null)
        })
    }
  }
}
